import {
  CheckboxProps as RadixCheckboxProps,
  Indicator as RadixCheckboxIndicator,
  Root as RadixCheckboxRoot,
} from '@radix-ui/react-checkbox'
import { CheckIcon } from '@radix-ui/react-icons'
import React from 'react'
import styled, { css } from 'styled-components'

const darkButton = css`
  background-color: rgba(0, 0, 0, 0);
  border-radius: 3px;
  height: 1.5rem;
  width: 1.5rem;
  border: 0.15rem solid ${(props) => props.theme.colors.grayscale[100]};
`

export interface CheckboxProps extends RadixCheckboxProps {
  $label?: string
  $ariaLabel?: string
}

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`
const CheckboxRoot = styled(RadixCheckboxRoot)<CheckboxProps>`
  ${() => darkButton};

  &[data-state='unchecked'] {
    background-color: ${(props) => props.theme.colors.slate['700_base']};
    border-color: ${(props) => props.theme.colors.slate[300]};
  }

  &:focus {
    outline: 2px solid ${(props) => props.theme.forecast.border};
  }

  transition-property: all;
  transition-duration: 0.2s;
`

const CheckboxIndicator = styled(RadixCheckboxIndicator)`
  color: white;
`

const CheckboxIcon = styled(CheckIcon)`
  height: 1rem;
  width: 1rem;
  transform: scale(1.75);
`
const CheckboxLabel = styled.label`
  font-family: Manrope;
  font-size: 1rem;
  padding-left: 0.5rem;
  user-select: none;
  color: ${(props) => props.theme.colors.slate[300]};
`

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { $label, $ariaLabel, ...rest } = props
  return (
    <CheckboxContainer>
      <CheckboxRoot
        aria-label={$ariaLabel ?? `Select ${$label}`}
        defaultChecked
        {...rest}>
        <CheckboxIndicator>
          <CheckboxIcon />
        </CheckboxIndicator>
      </CheckboxRoot>
      <CheckboxLabel>{$label}</CheckboxLabel>
    </CheckboxContainer>
  )
}
